<template>
  <div :style="styles.base">
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <c-base-dialog v-model="isShow" :option="option"
                   @close="closeBtnClick"
                   @confirm="closeBtnClick"
                   @cancel="closeBtnClick" v-transfer-dom>
      <template slot="body">
        <div :class="getCss('reward-tips')" v-if="!showDefaultGiftReceivePopText">
          <div>{{ rewardTips }}</div>
          <div v-for="(item,index) in packageNames" :key="index">{{ item }}</div>
        </div>
        <div :class="getCss('reward-tips')" v-else>
          <div>{{ showDefaultGiftReceivePopText }}</div>
        </div>
      </template>
      <template slot="fotter">
        <div v-if="checkGiftType('packageRealGift')" :style="actionStyle">
          <button
            class="ceiba-base-dialog-ft-button"
            :style="inputAddressStyle"
            @click="signAddress"
          >
          </button>
          <div :class="getCss('address-tips')">提示：实物奖励需填写地址才可以收到.~</div>
        </div>
        <div v-if="checkGiftType('cdk')" :style="actionStyle">
          <p :class="getCss('cdk-tips')">{{ CDKeyValue }}</p>
          <div :style="actionStyle" :class="getCss('cdk-action-button')">
            <button
              class="ceiba-base-dialog-ft-button"
              :style="copyStyle"
              @click="copyCDkText"
            >
            </button>
            <button
              class="ceiba-base-dialog-ft-button"
              :style="downloadGameButtonStyle"
              @click="startCallDownload"
            >
            </button>

          </div>

        </div>
      </template>
    </c-base-dialog>
    <c-base-dialog v-model="isShowPop" :option="popOption" @close="isShowPop=false" v-transfer-dom></c-base-dialog>
    <c-base-dialog v-model="isShowLastDia" :option="lastOption" @close="isShowLastDia=false" v-transfer-dom>
    </c-base-dialog>
<!--    开启个性化领取成功的弹框 -->
    <c-base-dialog
      v-model="isOpenIndividuationRemindDialog"
      :option="openIndividuationRemindDialogOption"
      @close="isOpenIndividuationRemindDialog = false"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('p-pop-content')">
          <img
            src="https://game.gtimg.cn/images/tgclub/act/a20220829GameActivity/images1/0923img04.png"
            alt=""
          />
          <p>获得奖励</p>
          <span :class="getCss('r-pop-msg')"
                v-if="!showDefaultGiftReceivePopText"
          >恭喜获得{{packageName}}</span>
          <span :class="getCss('r-pop-msg')" v-if="showDefaultGiftReceivePopText">
            {{showDefaultGiftReceivePopText}}</span>
          <p v-if="!isPackageRealFlag">道具奖励将自动发放至当前游戏账户<br>Q币奖励请前往已绑定QQ的钱包中查收</p>
          <p v-if="isPackageRealFlag">请在获奖记录中填写收货地址<br>活动结束后15个工作日发放奖励</p>
          <div :class="getCss('r-pop-btn')">
            <div :class="getCss('big-btn-grey')" @click="isOpenIndividuationRemindDialog = false"> 我知道了</div>
          </div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, baseComponents } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
// import CDialog from '../../../../ceiba-base-components/src/components/base-dialog';
export default {
  name: 'CButtonReward',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'button-reward-',
      status: this.configurationData.lockFlag ? 'lock' : 'reward', // lock, reward, rewarded
      rewardTips: '',
      packageName: '',
      isShow: false,
      isShowPop: false,
      isShowLastDia: false, // 关闭领奖弹窗后显示的弹窗
      roleInfoSecond: {}, // 保留二次绑定的角色
      isOpenDownload: true,
      CDKeyValue: '',
      copyCdkIconImage: 'https://game.gtimg.cn/images/js/img/tgclub/copyCDk.png',
      downloadGameIconImage: 'https://game.gtimg.cn/images/js/img/tgclub/downloadInit.png',
      packageRealGiftInputIcon: 'https://game.gtimg.cn/images/js/img/tgclub/downloadInit.png',
      copyCdkSuccessTrips: '',
      packageId: 0,
      checkLockSuccess: false, // 已经解锁是否成功
      checkAccessLockDone: false, // 是否有解锁过
      showDefaultGiftReceivePopText: '',
      isOpenIndividuationRemindDialog: false,
      isPackageRealFlag: false, // 是否抽中实物
      redirectTrips: '', // cdk跳转提示文案
      redirectUrl: '', // cdk跳转链接
    };
  },
  computed: {
    openIndividuationRemindDialogOption() {
      return  {
        fotter: true,
        header: false,
        confirm: false,
        cancel: false,
        close: true,
        positionType: 'bottom',
        width: '7.5rem',
        height: '5.3rem',
        dialogStyle: {
          color: '#242424',
          fontSize: '0.28rem',
          padding: '0 0',
          overflow: 'hidden',
        },
        maskClickable: false,
      };
    },
    backgroundImageMap() {
      return {
        lock: this.configurationData.lockImg,
        reward: this.configurationData.rewardImg,
        rewarded: this.configurationData.rewardedImg,
      };
    },
    option() {
      return Object.assign({}, this.dialogConfig, {
        header: this.receivedGiftPopTitle,
        fotter: true,
      });
    },
    popOption() {
      return Object.assign({}, this.dialogConfig, {
        dialogStyle: {
          backgroundImage: `url(${this.configurationData.popImg})`,
        },
        header: false,
        body: false,
        fotter: false,
      });
    },
    lastOption() {
      return Object.assign({}, this.dialogConfig, {
        dialogStyle: {
          backgroundImage: `url(${this.configurationData.lastDiaImg})`,
        },
        header: false,
        body: false,
        fotter: false,
      });
    },
    computedStyle() {
      const { isStretching, buttonDefaultBackgroundImage = '' } = this.configurationData;
      let backgroundImage = this.backgroundImageMap[this.status];
      // 未登录时默认按钮背景图
      if (!!buttonDefaultBackgroundImage && !this.isLogin) {
        backgroundImage = buttonDefaultBackgroundImage;
      }
      return {
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: isStretching ? '' : 'contain', // 是否拉伸
        backgroundRepeat: 'no-repeat',
        left: 0,
        top: 0,
      };
    },
    enable() {
      const packageStatus = this.quaInfo[this.configurationData.flowID];
      if (!packageStatus) return true;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
    packageNames() {
      return this.packageName ? this.packageName.split(',') : [];
    },
    wrapStyle() {
      return {
        top: this.styles.base.top,
        left: this.styles.base.left,
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    actionStyle() {
      return {
        width: this.dialogConfig.width,
      };
    },
    inputAddressStyle() {
      return {
        display: 'block',
        backgroundImage: `url(${this.packageRealGiftInputIcon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',

        margin: '0 auto',
      };
    },
    copyStyle() {
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundImage: `url(${this.copyCdkIconImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    downloadGameButtonStyle() {
      return {
        width: '2.2rem',
        height: '0.65rem',
        display: this.isOpenDownload ? 'block' : 'none',
        backgroundImage: `url(${this.downloadGameIconImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    packageIdMsgMapping() {
      const { packageIdMsgMappingList = [] } = this.configurationData;
      return packageIdMsgMappingList.map(item => ({
        packageId: parseInt(item.packageId, 10) || 0,
        msg: item.msg,
      }));
    },
    definedMsg() {
      if (this.configurationData.isOpenDefineMsg !== true) {
        return '';
      }
      if (this.packageIdMsgMapping.length === 0) return '';
      const { packageId } = this;
      const config = this.packageIdMsgMapping.find(item => item.packageId === packageId) || {};
      return config.msg ? config.msg : '';
    },
    receivedGiftPopTitle() {
      return this.configurationData?.receivedGiftPopTitle || '温馨提示';
    },
  },
  watch: {
    'configurationData.lockFlag': {
      handler(newVal) {
        this.status = newVal ? 'lock' : 'reward';
      },
      immediate: true,
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    // 解决弹窗容器里的领奖组件，点击弹窗才mounted没法解说资格刷新事件问题
    initMountedStatus() {
      if (!this.enable) this.status = 'rewarded';
    },
    initialize() {
      if (this.$isInEditor) return;
      this.initMountedStatus();
      // 强制不需要角色 解决不删档领取积分到游戏openid账号上
      const  { forbiddenRequireRole = false } =  this.configurationData;
      this.$refs.button.setClickHandler(this.doReward, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: forbiddenRequireRole === true ?  false :  this.actInfo.extendConfig.forceRole,
      });
      const self = this;
      const checkStatus = () => {
        if (self.enable) self.status = 'reward';
        else self.status = 'rewarded';
      };
      const checkLockStatus = async () => {
        if (this.configurationData.needCheckLock) {
          self.checkLockSuccess = await self.checkIfNotLock();
        }
        if (self.enable) {
          if (self.checkLockSuccess) {
            self.status = 'reward';
          } else {
            self.status = 'lock';
          }
        } else self.status = 'rewarded';
      };
      // ##################不用解锁
      if (!self.configurationData.lockFlag) {
        this.$onQuaRefreshed(checkStatus);
        return true;
      }
      // // ################## 开始需要解锁

      const { checkLockForceRole = false } = this.configurationData;
      // begin 解锁不需要角色
      if (!checkLockForceRole) {
        this.$onQuaRefreshed(async () => {
          // 有解锁能力
          checkLockStatus();
          if (self.status === 'rewarded') {
            return;
          }
          const notLock = await self.checkIfNotLock();
          if (!notLock) {
            return;
          }
          self.checkLockSuccess = true;
          self.checkAccessLockDone = true;
          // 已解锁
          checkStatus();
        });
        return true;
      }
      // end 解锁不需要角色

      // begin 解锁需要角色
      const randomKey = this.getRandomId();

      const autoHandleTask = () => {
        let temp = {};
        Object.defineProperty(window, randomKey, {
          get() {
            return temp;
          },
          set: async (newValue) => {
            temp = newValue;
            if (newValue && Object.keys(newValue).length >= 2) {
              //  角色与资格两者具备
              const notLock = await self.checkIfNotLock();

              if (!notLock) {
                return;
              }
              self.checkLockSuccess = true;
              self.checkAccessLockDone = true;
              // 已解锁
              checkStatus();
            }
          },
          enumerable: true,
          configurable: true,
        });
      };
      const setLockForceRoleFunc = (key) => {
        // if (Object.keys(window[randomKey]).length >= 2) return;
        window[randomKey] = {
          ...window[randomKey],
          [key]: 1,
        };
      };
      // 需要角色信息且需要
      autoHandleTask();
      this.$onRoleReady(async () => {
        setLockForceRoleFunc('onCheckLockRoleReady');
      });

      this.$onQuaRefreshed(async () => {
        checkLockStatus(); //  已解锁成功就不在解锁
        if (self.status === 'rewarded') {
          return;
        }
        setLockForceRoleFunc('onCheckLockQuaRefreshed');
        // 第一次没有解锁成功  重试尝试解锁
        if (this.isRoleReady && self.checkLockSuccess === false && self.checkAccessLockDone === true) {
          setLockForceRoleFunc('onCheckLockRoleReady');
        }
      });
    },
    getRandomId() {
      const id = `${Math.random().toString(36)
        .slice(-10)}_${Math.floor(Math.random() * 10000000)}`;
      return `__temp_lock_id_${id}`;
    },
    closeBtnClick() {
      this.isShow = false;
      if (!!this.configurationData.lastDiaImg && this.configurationData.closeBtnShowDia) {
        this.isShowLastDia = true;
      }
    },
    async checkIfNotLock() {
      try {
        const response = await this.flowRequest({
          flowId: this.configurationData.lockFlowID,
          params: {
            role: this.roleInfo,
          },
        });
        const { ret = 0 } = response;
        if (ret !== 0) {
          return false;
        }
        if (response.data.ret) {
          return false;
        }
        return true;
      } catch (e) {
        console.error('checkifnotlock fail,er=', e);
      }
      return false;
    },
    doReward() {
      // 当使用多游戏时，同时开启二次绑定角色功能
      if (this.configurationData.manyGameCode) {
        this.secondaryconfirm();
        return;
      }
      // 二次角色提醒弹窗
      if (this.configurationData.isSecondaryRoleConfirm) {
        this.secondaryconfirm();
        return;
      }
      this.getDoReward();
    },
    checkGiftType(checkType) {
      const { packageId } = this;
      if (packageId === 0 || !packageId) return false;
      const receiveGiftCustomConfig = this.$actInfo?.extendConfig?.receiveGiftCustomConfig ?? [];

      if (!receiveGiftCustomConfig || receiveGiftCustomConfig.length === 0) return false;
      const res = receiveGiftCustomConfig?.find(item => parseInt(item.gift_id, 10) === parseInt(packageId, 10));
      if (!res) return false;
      const { type = '' } = res || {};
      if (type === 'cdk' && checkType === 'cdk') {
        this.copyCdkSuccessTrips = res?.playload?.copyCdkSuccessTrips ?? '复制成功';
        this.copyCdkIconImage = res?.playload?.copyCdkIconImage ?? '';
        this.downloadGameIconImage = res?.playload?.downloadGameIconImage ?? '';
        this.isOpenDownload = parseInt(res?.playload?.isOpenDownload ?? 1, 10) === 2;

        this.redirectTrips = res?.playload?.redirectTrips ?? '立即前往兑换权益';
        this.redirectUrl = res?.playload?.redirectUrl ?? '';
        return true;
      }
      if (type === 'packageRealGift' && checkType === 'packageRealGift') {
        this.packageRealGiftInputIcon = res?.playload?.packageRealGiftInputIcon ?? '';
        return true;
      }
      return false;
    },
    async getDoReward() {
      this.reportClick({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
      });
      await this.doHook({
        name: 'click_reward',
        options: {
          meta: this.meta,
          configurationData: this.configurationData,
          reportPv: this.pageInfo.canvasConfig.reportPv,
        },
      });
      if (this.status !== 'reward') {
        if (this.status === 'lock' && this.configurationData.popImg) {
          this.isShowPop = true;
        }
        if (this.status === 'rewarded' && this.configurationData.needShowLastDia) {
          this.isShowLastDia = true;
        }
        return;
      }
      this.rewardTips = '恭喜你获得了';
      this.packageName = '';
      if (!(await this.doHook({ name: 'before_reward' }))) {
        return;
      }
      let tempRoleInfo = this.roleInfo;
      if (JSON.stringify(this.roleInfoSecond) !== '{}') {
        tempRoleInfo = this.roleInfoSecond;
      }
      const  params = {
        role: tempRoleInfo,
      };
      const  { forbiddenRequireRole = false } =  this.configurationData;
      // 禁止强制传角色
      if  (forbiddenRequireRole === true) {
        params.role = {};
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.flowID,
        params,
      });
      await this.doHook({
        name: 'after_reward',
        options: {
          meta: this.meta,
          configurationData: this.configurationData,
          reportPv: this.pageInfo.canvasConfig.reportPv,
          response,
        },
      });
      // 后置动作，上报等
      if (response.ret || response.data.ret
      ) {
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'reward',
          eventData: {
            gift_id: '',
            status: '0',
          },
        });
        this.alert(response.data.msg || response.msg);
        return;
      }
      this.refreshQua(); // 刷新礼包
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'reward',
        eventData: {
          gift_id: response.data.package_id || '',
          status: '1',
        },
      });
      const { package_id: packageId, packageId: otherPackageId,  package_cdkey: cdkey, gifts,
        package_real_flag: packageRealFlag } = response.data || {};
      // 设置礼包单
      this.packageId = parseInt(packageId, 10) || parseInt(otherPackageId, 10) || 0;
      this.CDKeyValue = cdkey;
      if (response.data.msg) {
        // 自定义提示
        if (this.definedMsg) {
          const giftsList = gifts ? gifts : [];
          const tempTextArray = this.definedMsg.split('|');
          for (let i = 0; i < tempTextArray.length; ++i) {
            tempTextArray[i] = tempTextArray[i].replace(/{{数量}}/g, giftsList?.[i]?.num ?? '0');
          }
          this.showDefaultGiftReceivePopText = tempTextArray.join(',');
        }
        this.packageName = response.data.msg.replace('恭喜您获得了礼包： ', '');
      } else {
        this.rewardTips = '领取成功';
      }
      // 个性化提示
      const { isOpenIndividuationRemindAfterReceive = false } =  this.configurationData;
      if (isOpenIndividuationRemindAfterReceive === true) {
        // 个性化弹框这里 根据实物显示不同的文本
        this.isPackageRealFlag = packageRealFlag !== '0' || this.checkGiftType('packageRealGift');
      }
      !isOpenIndividuationRemindAfterReceive ?   this.isShow = true : this.isOpenIndividuationRemindDialog = true ;
    },
    secondaryconfirm() {
      if (this.status === 'rewarded') {
        return;
      }
      let gameCode = this.actInfo.game_code;
      if (this.configurationData.manyGameCode) {
        gameCode = this.configurationData.manyGameCode;
      }
      baseComponents.gameRoleSelect.showConfirmGameRole({
        gameCode,
        roleInfoObj: this.roleInfo,
        option: {
          header: false,
          footer: false,
          height: '4.5rem',
          width: '7.2rem',
          dialogStyle: {
            color: 'rgb(221, 184, 106)',
          },
          confirmStyle: this.dialogConfig?.confirmStyle,
          cancelStyle: this.dialogConfig?.cancelStyle,
        },
      }).then((roleInfo) => {
        this.roleInfoSecond = roleInfo;
        this.getDoReward();
      });
    },
    startCallDownload() {
      this.$eventBus.$emit('ceiba:common:events:call-game-download', {});
    },
    signAddress() {
      this.isShow = false;
      this.$eventBus.$emit('ceiba:common:events:address-fill', {});
    },
    copyCDkText() {
      const textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      textarea.style.position = 'fixed';
      textarea.style.clip = 'rect(0 0 0 0)';
      textarea.style.top = '10px';
      textarea.value = this.CDKeyValue;
      textarea.select();
      document.execCommand('copy', true);
      document.body.removeChild(textarea);
      if (this.redirectUrl !== '') {
        const that = this;
        this.alert({ msg: this.redirectTrips, confirm() {
          window.location.href = that.redirectUrl;
        } });
      } else {
        this.$toast(this.copyCdkSuccessTrips || '复制cdk成功');
      }
      return true;
    },
  },
}
;
</script>
<style lang="scss">
@import './styles.scss';
</style>
